import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../general/Loading.js';
import '../css/components/Inventory.css';
import Select from 'react-select';

const Inventory = ({setResponse}) => {
  const navigate = useNavigate();
    const [item, setItem] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [showDelete, setShowDelete] = useState(false);
    const [barcodeQuery, setBarcodeQuery] = useState('');
    // const [visibleProducts, setVisibleProducts] = useState([]);
    // const [batchIndex, setBatchIndex] = useState(0);
        const [loading, setLoading] = useState(false);
        const [searchQuery, setSearchQuery] = useState('');
    const [brands, setBrands] = useState([]);
    const [category, setCategory] = useState([]);
    const [subCategory, setSubCategory] = useState([]);
const [selectedBrand, setSelectedBrand] = useState('');
const [selectedCategory, setSelectedCategory] = useState('');
const [selectedSubCategory, setSelectedSubCategory] = useState('');
const [categoryData, setCategoryData] = useState([]);
const location = useLocation();


const handleFetchProduct = async (brand = '', category = '', search = '', barcode = '') => {
const hasBrand = brand && brand.trim() !== '';
const hasCategory = category && category.trim() !== '';
const hasSearch = search && search.trim() !== '';
const hasBarcode = barcode && barcode.trim() !== '';

    if (!hasBrand && !hasCategory && !hasSearch && !hasBarcode) {
    setResponse({ message: 'Enter Item to Search', status: 'error' });

    setTimeout(() => {
      setResponse({ message: '', status: '' });
    }, 2000);

    return;
  }
  //   if (!searchQuery || searchQuery.trim() === '') {
  //   setResponse({ message: 'Enter Item to Search', status: 'error' });

  //   setTimeout(() => {
  //     setResponse({ message: '', status: '' });
  //   }, 2000);

  //   return;
  // }

  setLoading(true);
  try {
    const params = new URLSearchParams();
    
   if (hasSearch) params.append('searchQuery', search.trim());
if (hasBrand) params.append('brand', brand);
if (hasCategory) params.append('category', category);
if (hasBarcode) params.append('barcodeQuery', barcode.trim());

    const response = await fetch(`https://api.siddhabhairabistore.com/get-admin-product?${params.toString()}`);

    if (response.ok) {
      const data = await response.json();
console.log(data);

const safeParseArray = (value) => {
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};


const formattedData = data.map(product => ({
  ...product,
  parsedSellPrice: safeParseArray(product.sell_price)
}));

setItem(formattedData);
      setLoading(false);
    } else {
      console.error('Failed to fetch filtered products');
    }
  } catch (error) {
    console.error('Error fetching filtered products:', error);
  } finally {
    setLoading(false);

  }
};

                const fetchCategory = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://api.siddhabhairabistore.com/get-category');

                if (response.ok) {
                    const data = await response.json();
                     setCategoryData(data);

const uniqueBrands = [...new Set(
  data
    .map(item => item.brand)
    .filter(Boolean)
    .map(str => str)
)];

const uniqueCategories = [...new Set(
  data
    .map(item => item.category)
    .filter(Boolean)
    .map(str => str)
)];

const uniqueSubCategories = [...new Set(
  data
    .map(item => item.sub_category)
    .filter(Boolean)
    .map(str => str)
)];

setBrands(uniqueBrands);
setCategory(uniqueCategories);
setSubCategory(uniqueSubCategories);

  setLoading(false);
                } else {
                    console.error('Failed to fetch users');
                }
            } catch (error) {
               
                console.error('Error fetching data:', error);
            } finally {
 setLoading(false);
            }
        };

useEffect(() => {
  const restoreData = async () => {

    if (location.state?.inventoryState) {
      const prev = location.state.inventoryState;

      setSearchQuery(prev.searchQuery || '');
      setSelectedBrand(prev.selectedBrand || '');
      setSelectedCategory(prev.selectedCategory || '');
      setSelectedSubCategory(prev.selectedSubCategory || '');

    await fetchCategory();

if (
  prev.selectedBrand ||
  prev.selectedCategory)
      await handleFetchProduct(
        prev.selectedBrand,
        prev.selectedCategory
      );

      return;
    }

  };
fetchCategory();
  restoreData();
}, []);


const filteredCategories = selectedBrand
  ? [...new Set(
      categoryData
        .filter(item => item.brand?.trim().toLowerCase() === selectedBrand.trim().toLowerCase())
        .map(item => item.category?.trim())
        .filter(Boolean)
    )]
  : category;



const filteredSubCategories = categoryData
  .filter(item => {
    const matchesBrand = selectedBrand ? item.brand?.trim().toLowerCase() === selectedBrand.trim().toLowerCase() : true;
    const matchesCategory = selectedCategory ? item.category?.trim().toLowerCase() === selectedCategory.trim().toLowerCase() : true;
    return matchesBrand && matchesCategory;
  })
  .map(item => item.sub_category?.trim())
  .filter(Boolean);



const filterProduct = useMemo(() => {
  const list = Array.isArray(item) ? item : [];

  // const query = searchQuery.trim().toLowerCase();

  return list.filter(product => {
    // const name = product.name?.toLowerCase() || '';

    // const matchesName = query === '' || name.includes(query);

    // const matchesBrand =
    //   !selectedBrand ||
    //   product.brand?.trim().toLowerCase() === selectedBrand.trim().toLowerCase();

    // const matchesCategory =
    //   !selectedCategory ||
    //   product.category?.trim().toLowerCase() === selectedCategory.trim().toLowerCase();

    const matchesSubCategory =
      !selectedSubCategory ||
      product.sub_category?.trim().toLowerCase() === selectedSubCategory.trim().toLowerCase();

    return matchesSubCategory;
  });
}, [item, selectedSubCategory]);

    const handleShowDelete = (product) => {
      setSelectedProduct(product);
      setShowDelete(true);
    }

      const handleDelete = async (productId) => {
    try {
      const response = await fetch(`https://api.siddhabhairabistore.com/delete-product/${productId}`, {
        method: 'PUT',
      });

      if (response.ok) {
setItem((prevProducts) => prevProducts.filter((product) => product.id !== productId));
// setVisibleProducts((prev) => prev.filter((product) => product.id !== productId));
        setResponse({ message: 'Product deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setShowDelete(false);
      } else {
                setResponse({ message: 'Unable to Delete product.', status: 'error' });
        setTimeout(() => {
          setResponse('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };


  const brandOptions = brands.map(brand => ({ value: brand, label: brand }));
const categoryOptions = filteredCategories.map(cat => ({ value: cat, label: cat }));
const subCategoryOptions = filteredSubCategories.map(subCat => ({ value: subCat, label: subCat }));


useEffect(() => {
  const input = document.getElementById("barcodeInput");
  if (input && document.activeElement !== input) {
    input.focus();
  }
}, []);


  return (
    <>
    <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>Product's Inventory</p>
          <button className='edit-btn' onClick={() => navigate('/add-product', {
  state: {
    inventoryState: {
      searchQuery,
      selectedBrand,
      selectedCategory,
      selectedSubCategory,
      from: 'Inventory'
      // items: item,
      // brands,
      // category,
      // subCategory,
      // categoryData
    }
  }
})}>Add Product</button>
        </div>

<div className='row mt-3 mb-2'>

  <div className='col-md-6 col-sm-6 col-12 mb-2'>

                    <div className='d-flex bg-white rounded-2 py-2'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue py-2 px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-white w-100 py-0"
                            placeholder="Search by Name"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    </div>

<div className='col-md-6 col-sm-6 col-12 mb-2'>
  <div className='d-flex bg-white rounded-2 py-2'>
    <i className="fa-solid fa-barcode text-darkblue py-2 px-2"></i>
    <input
      id="barcodeInput"

      type="text"
      className="profile-control rounded-2 border-0 bg-white w-100 py-0"
      placeholder="Scan Barcode"
      value={barcodeQuery}
      onChange={(e) => setBarcodeQuery(e.target.value)}
      onKeyDown={(e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleFetchProduct('', '', '', barcodeQuery.trim());
      setBarcodeQuery('');
    }
  }}
    />
  </div>
</div>


<div className='col-md-3 col-sm-6 col-12 my-2'>
<Select
  options={brandOptions}
  value={selectedBrand ? { value: selectedBrand, label: selectedBrand } : null}
  // onChange={(selectedOption) => setSelectedBrand(selectedOption?.value || '')}
onChange={(selectedOption) => {
  const value = selectedOption?.value || '';

  setSelectedBrand(value);
  setSelectedCategory('');
  setSelectedSubCategory('');
}}  placeholder="Select Brand"
  isClearable
/>
  </div>


<div className='col-md-3 col-sm-6 col-12 my-2'>
<Select
  options={categoryOptions}
  value={selectedCategory ? { value: selectedCategory, label: selectedCategory } : null}
  // onChange={(selectedOption) => setSelectedCategory(selectedOption?.value || '')}
onChange={(selectedOption) => {
  const value = selectedOption?.value || '';

  setSelectedCategory(value);
  setSelectedSubCategory('');
}}  placeholder="Category"
  isClearable
/>
  </div>
{/* 
  {filterProduct.length !== 0 && selectedCategory && (
  <div className='col-md-3 col-sm-6 col-12 my-2'>
    <Select
      options={subCategoryOptions}
      value={selectedSubCategory ? { value: selectedSubCategory, label: selectedSubCategory } : null}
      onChange={(selectedOption) => setSelectedSubCategory(selectedOption?.value || '')}
      placeholder="Sub Category"
      isClearable
    />
  </div>
)} */}



<div className='col-md-3 col-sm-6 col-12 my-1'>
<button className='edit-btn px-3 w-100' onClick={() => 
  handleFetchProduct(selectedBrand, selectedCategory, searchQuery, barcodeQuery)}>
  <i className="fa-solid fa-filter pe-2"></i>Apply Filter
</button>
</div>


  </div>
{/* row ends */}


        <div className='table-responsive bg-white rounded-2 px-3 py-3'>
          <table className='w-100'>
              <tr className='inventory-row d-flex'>
                <th style={{flex: 1}}>Name</th>
                <th style={{flex: 0.6}}>Brand</th>
                <th style={{flex: 0.6}}>Category</th>
                {/* <th style={{flex: 0.6}}>Sub Category</th> */}
                {/* <th style={{flex: 0.6}}>Purchase Price</th> */}
                <th style={{flex: 0.6}}>MRP</th>
                <th style={{flex: 1}}>Sell Pricings</th>
                <th style={{flex: 0.4}}>Stock</th>
                <th style={{flex: 0.4}}>Activity</th>
              </tr>

              {filterProduct.map(product => (
                <tr key={product.id} className='inventory-row d-flex'>
                  <td style={{flex: 1}}>{product.name}</td>
                  <td style={{flex: 0.6}}>{product.brand}</td>
                  <td style={{flex: 0.6}}>{product.category}</td>
                  {/* <td style={{flex: 0.6}}>{product.sub_category}</td> */}
                  {/* <td style={{flex: 0.6}}>₹{product.purchase_price}</td> */}
                  <td style={{flex: 0.6}}>₹{product.mrp}</td>
<td style={{flex: 1}}>
  <table>
      <tr>
        <td>Qty</td>
        <td className='ps-3'>Price</td>
      </tr>
{/* {(() => {
  let prices = [];
  try {
    prices = JSON.parse(product.sell_price);
    if (!Array.isArray(prices)) prices = []; // <- ensure it's an array
  } catch (e) {
    console.error('Invalid sell_price format:', product.sell_price);
    prices = [];
  }
  return prices.map((p, i) => (
    <tr key={i}>
      <span>{p.qty}</span>
      <span className='ps-4'>₹{p.price}</span>
    </tr>
  ));
})()} */}
{product.parsedSellPrice.map((p, i) => (
  <tr key={i}>
    <td>{p.qty}</td>
    <td className="ps-4">₹{p.price}</td>
  </tr>
))}

  </table>
</td>
                  <td style={{flex: 0.4}}>{product.stock}</td>
                  <td style={{flex: 0.4}} className='fs-5 cursor-pointer'>
                    <span onClick={() => navigate('/edit-product', {
  state: {
    product,
    inventoryState: {
      searchQuery,
      selectedBrand,
      selectedCategory,
      selectedSubCategory,
      // items: item,
      // brands,
      // category,
      // subCategory,
      // categoryData
    }
  }
})}><i class="fa-solid fa-pen-to-square text-success"></i></span>
                  <span className='ms-2' onClick={() => handleShowDelete(product)}><i class="fa-solid fa-trash text-danger"></i></span></td>
                </tr>
              ))}
          </table>
        </div>
      </div>
    </section>

{showDelete && (
  <>
                                  <section className="detail-dialog animate__animated animate__zoomIn px-2">
                                    <div className='detail-dialog-inner text-center col-lg-4 col-11 mx-auto px-lg-5 py-lg-5 px-3 py-3'>

<p className='page-title fs-6'>Want to Delete '{selectedProduct.name}'?</p>

<button className='edit-btn' onClick={() => handleDelete(selectedProduct.id)}>Yes</button>&nbsp;&nbsp;
<button className='close-btn' onClick={() => setShowDelete(false)}>No</button>

</div>
</section>
  </>
)}

            {loading && <Loading setLoading={setLoading} />}
            </>
);
};

export default Inventory;
